import { MotionIconWrapper, variantsRotate } from '@comeon/ui';

import Icon, { ICON_BOTTOM, ICON_RIGHT } from '~/components/icon';
import { textKeysNewQDMethodCollapse } from '~/components/payment/quick-deposit-beta/components-v2/constants';
import NewQDMethodsCollapseList from '~/components/payment/quick-deposit-beta/components-v2/methods-list';
import {
	DepositInfo,
	InstantDepositInfoForMethods,
	QuickDepositProvider
} from '~/components/payment/quick-deposit-beta/types';
import { LOADING } from '~/components/payment/quick-deposit-beta/utils/constants';
import useTranslations from '~/components/translation/use-translations';
import usePaymentTracking from '~/components/payment-beta/deposit/hooks/use-payment-tracking';

import { ChangeMethodContainer, MethodsCollapse, MethodsCollapseTitle } from './styles';

const motionTransitionSettings = {
	x: { type: 'spring' as const, stiffness: 100, damping: 100 }
};

type Props = {
	depositInfo: DepositInfo;
	methodListToggle: boolean;
	onMoreMethodsClick: () => void;
	selectMethodAndExecute: (provider: InstantDepositInfoForMethods) => void;
	selectedMethod: QuickDepositProvider;
	toggleMethodList: (value: boolean) => void;
	views: string[];
};

const NewQDMethodsCollapse = ({
	depositInfo,
	methodListToggle,
	onMoreMethodsClick,
	selectMethodAndExecute,
	selectedMethod,
	toggleMethodList,
	views
}: Props) => {
	const { translations } = useTranslations(textKeysNewQDMethodCollapse);
	const { trackQDEvent } = usePaymentTracking();

	const { NEW_QUICK_DEPOSIT_CHANGE_PAYMENT_METHOD_LIST } = translations;
	const numberOfMethods = depositInfo?.instantDepositInfoForMethods.length;
	const showMethodsSelection = numberOfMethods > 1;

	const handleMethodsClick = () => {
		if (showMethodsSelection) {
			trackQDEvent({
				pixel_deposit_action: 'click-change-method-drop-down'
			});
			toggleMethodList(!methodListToggle);
		} else {
			onMoreMethodsClick();
		}
	};

	return (
		<ChangeMethodContainer>
			<MethodsCollapseTitle
				data-at="new-qd-change-method-title"
				disabled={views.includes(LOADING)}
				onClick={handleMethodsClick}
				className="button u-pt0"
			>
				<span>{NEW_QUICK_DEPOSIT_CHANGE_PAYMENT_METHOD_LIST}</span>
				<MotionIconWrapper
					animate={methodListToggle ? 'up' : 'down'}
					className="icon-wrapper u-ml0"
					height={24}
					initial="down"
					transition={motionTransitionSettings}
					variants={variantsRotate}
					width={24}
				>
					<Icon height={24} width={24} type={showMethodsSelection ? ICON_BOTTOM : ICON_RIGHT} />
				</MotionIconWrapper>
			</MethodsCollapseTitle>
			<MethodsCollapse toggle={methodListToggle} items={numberOfMethods}>
				<NewQDMethodsCollapseList
					depositInfo={depositInfo}
					onMoreMethodsClick={onMoreMethodsClick}
					selectMethodAndExecute={selectMethodAndExecute}
					selectedMethod={selectedMethod}
				/>
			</MethodsCollapse>
		</ChangeMethodContainer>
	);
};

export default NewQDMethodsCollapse;
